import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { INQUIRY_TAB_LIST_URL, INQUIRY_LIST_URL } from "../../utils/urls";
import instance from "../../services/services";
import BoardForm from "../../components/MyPage/BoardForm";
import PaginationSection from "../../components/Product/Pagination";
import useUserStore from "../../store/userStore";
import PopupLoginError from "../../components/Popup/LoginError";
import { useLanguage } from "../../hooks/useLanguage";


function CommInquiryList(){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { myInfo } = useOutletContext();
  const [activeTab, setActiveTab] = useState('all');
  const [inquiryTabList, setInquiryTabList] = useState([]);
  const [inquiryList, setInquiryList] = useState([]);
  const [currentBoardType, setCurrentBoardType] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 12; // 페이지당 표시할 항목 수
  const { memberTokens } = useUserStore();
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);

    const inquiryTabKeyMap = {
        "전체": "faq_tab_all",
        "일반문의": "inquiry_tab_general",
        "장비문의": "inquiry_tab_equipment",
        "이벤트문의": "inquiry_tab_event",
        "제휴문의": "inquiry_tab_partnership",
        "고객의견함": "inquiry_tab_feedback",
        "기타": "inquiry_tab_etc"
    };

  const handleClickForm = () => {
    if (!memberTokens) {
      setIsPopupLoginError({
        message: t('login_required'),
        action: 'navigate_login'
      });
      return;
    }
    navigate('/community/inquiry/write');
  };

  const handleConfirm = () => {
    navigate('/login');
  };

  // 1:1문의 탭 api
  useEffect(() => {
    const fetchInquiryTab = async () => {
      try {
        const response = await instance.post(INQUIRY_TAB_LIST_URL);
        setInquiryTabList(response.data.data);

      } catch (error) {
        console.error("1:1문의 탭 목록 가져오기실패:", error);
      }
    };
    fetchInquiryTab();
  }, []);


  // 1:1문의 리스트 api
  useEffect(() => {
    const fetchInquiryList = async () => {
      try {
        const inquiryResponse = await instance.post(INQUIRY_LIST_URL, {
          boardid: "mbqna",
          member_chk: "N",
          offset: currentPage,
          board_type: currentBoardType,
          member_seq: "",
          limit: itemsPerPage
        });
        setInquiryList(inquiryResponse.data.data.data);
        setTotalCount(inquiryResponse.data.data.cntRow);

      } catch (error) {
        console.error("1:1문의 목록 가져오기실패:", error);
      }
    };
    fetchInquiryList();
  }, [currentBoardType, currentPage]);



  const handleTabClick = (value, codecd) => {
    setActiveTab(value);
    setCurrentPage(1); // 탭 변경 시 페이지 1로 초기화

    // 전체 탭을 클릭한 경우 board_type을 빈 문자열로 설정
    if (value === 'all') {
      setCurrentBoardType("");
    } else {
      // 다른 탭을 클릭한 경우 해당 탭의 codecd를 board_type으로 설정
      const selectedTab = inquiryTabList.find(tab => tab.value === value);
      if (selectedTab) {
        setCurrentBoardType(selectedTab.codecd);
      }
    }
  };

  // 페이지 변경 핸들러
  const handlePageChange = (page) => {
    setCurrentPage(page);
    // window.scrollTo(0, 0); // 페이지 변경 시 상단으로 스크롤
  };

  // 화살표 클릭 핸들러 (페이지 변경을 처리하는 handlePageChange와 동일하게 처리)
  const handleArrowClick = (page) => {
    handlePageChange(page);
  };

  return(
    <div className="board_container">
      <h3 className="commu_title noline">{t("inquiry")}</h3>

      <div className="commu_box btm_btn_box">
        <div className="column flex-8">
          <h4 className="p2">{t("daypay_with_you_0617")}</h4>
          <p className="g-80 b1_2">
          {t("daypay_1_1_inquiry")}<br/>
          {t("camera_rental_related")}
          </p>
        </div>
        <button
          type="button"
          className="default_btn black"
          onClick={handleClickForm}
        >
          {t("Contact_us")}
        </button>
      </div>

      <div className="round_tab line mt_32">
        <ul className="tab_list">
            <li
              className={`tab_item ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => handleTabClick('all')}
            >
              <button className="flex-center-4 flex-justify-center">
              {t("faq_tab_all")}
              </button>
            </li>

            {inquiryTabList.map((tab, index) => (
              <li
                key={index}
                className={`tab_item ${activeTab === tab.value ? 'active' : ''}`}
                onClick={() => handleTabClick(tab.value)}
              >
                <button className="flex-center-4 flex-justify-center">
                    {t(inquiryTabKeyMap[tab.value] || tab.value)}
                </button>
              </li>
            ))}
        </ul>
      </div>

      <div className="board_container form_board">
        <BoardForm
          isMyBoard={true}
          formType="inquiry"
          boardList={inquiryList}
          member_seq={myInfo?.member_seq}
        />
      </div>

      {totalCount > 0 && (
        <PaginationSection
          totalCount={totalCount}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onArrow={handleArrowClick}
        />
      )}

      <PopupLoginError
        isPopup={isPopupLoginError}
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
      />
    </div>
  )
};

export default CommInquiryList;
